import '.i{height:100%;}.ssr-plugin'
import '.cp{max-width:480px;}.ssr-plugin'
import '.er{margin-left:8px;}.ssr-plugin'
import '.es{margin-right:8px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.et{max-height:calc(100vh - 192px);}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.cq{border-radius:24px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.ee{backdrop-filter:blur(48px);}.ssr-plugin'
import '.ef{-webkit-backdrop-filter:blur(48px);}.ssr-plugin'
import '.d3{flex-direction:row;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.eu{padding:20px 24px;}.ssr-plugin'
import '.ev{font-size:20px;}.ssr-plugin'
import '.ew{margin-top:4px;}.ssr-plugin'
import '.ex{overflow-y:scroll;}.ssr-plugin'
import '.ey{scrollbar-width:none;}.ssr-plugin'
import '.f{flex:1;}.ssr-plugin'
import '.b3{margin-bottom:16px;}.ssr-plugin'
import '.ca{text-align:left;}.ssr-plugin'
import '.as{gap:16px;}.ssr-plugin'
import '.ez{height:1px;}.ssr-plugin'
import '.f0{margin:24px auto;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { IconButton } from './IconButton.js'
import { Icon } from '../assets/icons/index.js'
import { useLanguage } from '../hooks/useLanguage.js'
import { getLanguageName } from '../utils/getLanguageName.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { MOBILE } from '../utils/breakpoints.js'
import { LANGUAGES } from '../../../schema/locales.js'
import { useVotingRegion } from '../hooks/useVotingRegion.js'
import { useDictionary } from '../hooks/useDictionary.js'

const allTheLanguages = Object.keys(LANGUAGES).sort((a, b) =>
  getLanguageName(a).localeCompare(getLanguageName(b)),
)

const POPULAR_LANGUAGES = ['en', 'de', 'fr']

export const SelectLanguageModal = ({ setModal }) => {
  const track = useTrack('menu')
  const [lang, setLanguage] = useLanguage()
  const [{ code }] = useVotingRegion()

  const { selectLanguage, recommended, allLanguages } = useDictionary()

  const regionalLanguages = lang.options.filter((code) => code !== 'en')
  const recommendedLanguages =
    code === 'ROW'
      ? ['en', 'de', 'fr']
      : [
          ...regionalLanguages,
          ...POPULAR_LANGUAGES.filter(
            (code) => !regionalLanguages.includes(code),
          ),
        ]

  return (
    <ModalWrapper onDismiss={() => setModal(false)}>
      <styled.div className="i cp er es a et ag cq o p ee ef"
        style={{
          backgroundColor: `${transparentColor(colors.secondary, 0.1)}`,
          border: `1px solid ${colors.border}`,
          animation: MODAL_PANEL_ANIMATION,
          [MOBILE]: {
            maxHeight: 'calc(100vh - 16px)',
            backgroundColor: `${transparentColor(colors.secondary, 0.8)}`,
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
          },
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="o d3 am v eu"
          style={{
            borderBottom: `1px solid ${colors.border}`,
          }}
        >
          <h3 className="ev ew">
            {selectLanguage}
          </h3>
          <IconButton
            variant="ghost"
            id="language-modal-action-close-button"
            icon={<Icon type="closeIcon" />}
            onClick={() => setModal(false)}
          />
        </div>
        <styled.div className="ex ey f eu"
          style={{
            '& a': {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              userSelect: 'none',
              transition: 'all .2s ease-out',
              margin: '-8px -16px',
              padding: '8px 16px',
              borderRadius: '24px',
              border: '1px solid transparent',
              scale: '1',
              '&:hover': {
                background: `${colors.border}`,
                border: `1px solid ${colors.border}`,
                scale: '.98',
              },
            },
          }}
        >
          <p className="subtext b3 ca"
          >
            {recommended}
          </p>

          <div className="o p as"
          >
            {recommendedLanguages.map((item) => {
              return (
                <styled.a
                  key={item}
                  onClick={() => {
                    track(
                      AnalyticsEvent.MENU_LANG_CHANGE,
                      `${lang.code}->${item}`,
                    )
                    setLanguage(item)
                    setModal(false)
                  }}
                >
                  {getLanguageName(item)} <Icon type="chevronRightIcon" />
                </styled.a>
              )
            })}
          </div>

          <div className="ez a f0"
            style={{
              backgroundColor: colors.border,}}
          />

          <p className="subtext b3 ca"
          >
            {allLanguages}
          </p>
          <div className="o p as"
          >
            {allTheLanguages.map((item) => {
              return (
                <styled.a
                  id={`language-modal-action-set-language-${item}`}
                  key={item}
                  onClick={() => {
                    track(
                      AnalyticsEvent.MENU_LANG_CHANGE,
                      `${lang.code}->${item}`,
                    )
                    setLanguage(item)
                    setModal(false)
                  }}
                >
                  {getLanguageName(item)} <Icon type="chevronRightIcon" />
                </styled.a>
              )
            })}
          </div>
        </styled.div>
      </styled.div>
    </ModalWrapper>
  )
}
